module.exports = "data:image/jpeg;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJpbWcvanVlZ28tNSAtIENvcHkuNzE3ZDk4NDAuanBnIjs="